<h5 class="px-1 py-1 border-bottom"> {{words[language].personalInformation}} </h5>
<form [formGroup]="customerInformation" class="row m-0 p-1">

    <!-- firstName input-->
    <div class="form-group col-md-2 col-sm-12">
        <label for="firstName"> {{words[language].firstName}}</label>
        <input class="form-control text-dark" type="text" id="firstName" formControlName="firstName" placeholder="{{words[language].enterFirstName}}" autocomplete="off">
        @if (firstName.invalid && firstName.dirty) {
        <span class="text-danger">{{words[language].InvalidfirstName}}</span>
        }
    </div>
    <!-- lastName input -->
    <div class="form-group col-md-2 col-sm-12">
        <label for="lastName">{{words[language].lastName}}</label>
        <input class="form-control text-dark" type="text" id="lastName" formControlName="lastName" placeholder="{{words[language].enterLastName}}" autocomplete="off">
        @if (lastName.invalid && lastName.dirty) {
        <span class="text-danger">{{words[language].invalidLastName}}</span>
        }
    </div>
    <!-- email adress input -->
    <div class="form-group col-md-3 col-sm-12">
        <label for="email">{{words[language].emailAddress}}</label>
        <input class="form-control text-dark" type="email" id="email" formControlName="email" placeholder="{{words[language].enterEmailAddress}}" autocomplete="off">
        @if (email.invalid && email.dirty) {
        <span class="text-danger">{{words[language].invalidEmailAddress}}</span>
        }
    </div>
    <!-- Contact Phone input -->
    <div class="form-group col-md-3 col-sm-12">
        <label for="phone">{{words[language].phoneNumber}}</label>
        <div class="input-group input-group-merge">
            <div class="input-group-append">
                <div class="input-group-text">
                    <span class="mdi mdi-phone"></span>
                </div>
            </div>
            <input class="form-control text-dark" formControlName="phone" type="tel" id="phone" placeholder="{{words[language].enterPhoneNumber}}" autocomplete="off">
        </div>
        @if (phone.invalid && phone.dirty) {
        <span class="text-danger">{{words[language].invalidPhoneNumber}}</span>
        }
    </div>
    <!-- Language input -->
    <div class="form-group col-md-3 col-sm-12">
        <label for="language">{{words[language].language}}</label>
        <select name="language" id="language" class="form-control text-dark" formControlName="languagePreference" (change)="changeLanguage($event)">
            @for (languageObj of languagesList; track languageObj) {
            <option [value]="languageObj.value">{{
                words[language][languageObj.name ] }}</option>
            }
        </select>
    </div>


    <!-- log in button -->
    <div class="form-group col-md-12 col-sm-12 d-flex align-items-end justify-content-end">
        <button class="btn btn-success mx-1" id="submitSendInformation" (click)="save()" type="submit" [disabled]="loading || customerInformation.invalid" id="save">
            <span>
                @if (loading) {
                <img src="../../../assets/images/loading.svg" alt="" height="20" class="mr-2">
                }
                {{words[language].save}}
            </span>
        </button>
        <button class="btn btn-light" id="submitSendInformation" type="submit" id="cancel" (click)="cancel()">
            <span>{{words[language].cancel}}</span>
        </button>

    </div>
</form>